import styled from 'styled-components'
import screen from '../../styles/media'

export const CustomLogo = styled.img`
    ${(props) => (props.cursor ? 'cursor: pointer;' : '')}
    width: ${(props) => props.width};
    height: ${(props) => props.height};
    ${(props) => (props.media && props.media === 'xl' ? screen.xl` height: 100%; ` : '')}
`
